import { render, staticRenderFns } from "./leader.vue?vue&type=template&id=d32caf42&scoped=true"
import script from "./leader.vue?vue&type=script&lang=js"
export * from "./leader.vue?vue&type=script&lang=js"
import style0 from "./leader.vue?vue&type=style&index=0&id=d32caf42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32caf42",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/interview/leader.vue
// module id = null
// module chunks = 